"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHOW_INFO_VALUES = exports.COMPACT_SHOW_INFO_VALUES = exports.STRIP_SHOW_INFO_VALUES = exports.CLASSIC_SHOW_INFO_VALUES = void 0;
var tslib_1 = require("tslib");
var ON_MOUSE_OVER = 1;
var ALWAYS = 2;
var NEVER = 3;
exports.CLASSIC_SHOW_INFO_VALUES = [ON_MOUSE_OVER, ALWAYS];
exports.STRIP_SHOW_INFO_VALUES = tslib_1.__spreadArray(tslib_1.__spreadArray([], exports.CLASSIC_SHOW_INFO_VALUES, true), [NEVER], false);
exports.COMPACT_SHOW_INFO_VALUES = exports.STRIP_SHOW_INFO_VALUES;
exports.SHOW_INFO_VALUES = {
    ON_MOUSE_OVER: ON_MOUSE_OVER,
    ALWAYS: ALWAYS,
    NEVER: NEVER,
};
//# sourceMappingURL=show-info-values.js.map